import React from 'react';
import {useSelector} from "react-redux";

import {INSIGHT_LEVELS} from './index.js';
import GrowthTableRow from './GrowthTableRow';

export default function({growth_insights, growthMin, disabledImpactStudies, setDisabledImpactStudies}) {
    const dashboard_data = useSelector(state => state.dashboard_data);

    const renderHeader = () => {
        const onClick = (impact_study) => (e) => {
            e.preventDefault();
            if (impact_study === 'reset') {
                if (disabledImpactStudies.length > 0) {
                    setDisabledImpactStudies([]);
                }
            } else if (!disabledImpactStudies.includes(impact_study)) {
                setDisabledImpactStudies([...disabledImpactStudies, impact_study]);
            }
            return false;
        }

        const render_impact = dashboard_data.super_impact.map((d) => {
            return (
                <div key={d.impact_study} className="one-impact flex-row flex-v-center flex-gap-20">
                    <div>
                        {d.impact_study}
                    </div>
                    <i className="fas fa-ban" onClick={onClick(d.impact_study)}></i>
                </div>
            );
        });

        return (
            <div className="one-row flex-row flex-gap-25">
                <div className="growth-t-left-header">
                    <a href="#" onClick={onClick('reset')}>{`reset ->`}</a>
                </div>
                {render_impact}
            </div>
        );
    }

    const renderHeader2 = () => {
        const render_all = dashboard_data.super_impact.map((d) => {
            const render_level = INSIGHT_LEVELS.map((l) => {
                return (
                    <div key={l} className="one-level">
                        {l}
                    </div>
                );
            });
            return (
                <div key={d.impact_study} className="one-impact flex-row flex-gap-15">
                    {render_level}
                </div>
            );
        });

        return (
            <div className="one-row flex-row flex-gap-25">
                <div className="growth-t-left-header"></div>
                {render_all}
            </div>
        );
    }

    const renderImpact = () => {
        const render_all = growth_insights.impact.map((d, k) => {
            return (
                <div key={k} className="one-row flex-row flex-v-center flex-gap-25">
                    <div className="growth-t-left-header">
                        {`Overall`}
                    </div>
                    <GrowthTableRow
                        row_data={d}
                        growthMin={growthMin}
                    />
                </div>
            );
        });

        return (
            <div className="">
                {render_all}
            </div>
        );
    }

    const renderSkill = () => {
        const render_all = growth_insights.skill.map((d, k) => {
            return (
                <div key={k} className="one-row flex-row flex-v-center flex-gap-25">
                    <div className="growth-t-left-header">
                        {dashboard_data.super_skill_const[k].code}
                        <br />
                        {dashboard_data.super_skill_const[k].name}
                    </div>
                    <GrowthTableRow
                        row_data={d}
                        growthMin={growthMin}
                    />
                </div>
            );
        });

        return (
            <div className="">
                {render_all}
            </div>
        );
    }

    const renderCategory = () => {
        const render_all = growth_insights.category.map((d, k) => {
            return (
                <div key={k} className="one-row flex-row flex-v-center flex-gap-25">
                    <div className="growth-t-left-header">
                        {dashboard_data.super_category_const[k]}
                    </div>
                    <GrowthTableRow
                        row_data={d}
                        growthMin={growthMin}
                    />
                </div>
            );
        });

        return (
            <div className="">
                {render_all}
            </div>
        );
    }

    const renderDomain = () => {
        const render_all = growth_insights.domain.map((d, k) => {
            return (
                <div key={k} className="one-row flex-row flex-v-center flex-gap-25">
                    <div className="growth-t-left-header">
                        {dashboard_data.super_domain_const[k]}
                    </div>
                    <GrowthTableRow
                        row_data={d}
                        growthMin={growthMin}
                    />
                </div>
            );
        });

        return (
            <div className="">
                {render_all}
            </div>
        );
    }

    const renderGrade = () => {
        const render_all = growth_insights.grade.map((d, k) => {
            return (
                <div key={k} className="one-row flex-row flex-v-center flex-gap-25">
                    <div className="growth-t-left-header">
                        {`Grade`} {dashboard_data.super_grade_const[k].join(' & ')}
                    </div>
                    <GrowthTableRow
                        row_data={d}
                        growthMin={growthMin}
                    />
                </div>
            );
        });

        return (
            <div className="">
                {render_all}
            </div>
        );
    }

    const renderSchool = () => {
        const render_all = growth_insights.school.map((d, k) => {
            return (
                <div key={k} className="one-row flex-row flex-v-center flex-gap-25">
                    <div className="growth-t-left-header">
                        {dashboard_data.super_school_const[k].name}
                    </div>
                    <GrowthTableRow
                        row_data={d}
                        growthMin={growthMin}
                    />
                </div>
            );
        });

        return (
            <div className="">
                {render_all}
            </div>
        );
    }

    if (!dashboard_data.super_impact) {
        return null;
    }

    const div_width = dashboard_data.super_impact_const.length * 450 + 200;

    return (
        <div className="growth-table" style={{minWidth: div_width}}>
            <div className="growth-t-top-header">
                {renderHeader()}
                {renderHeader2()}
            </div>
            {renderImpact()}
            <div className="section"></div>
            <div className="one-row">
                <div className="growth-t-left-header">{`Skills`}</div>
            </div>
            {renderSkill()}
            <div className="section"></div>
            <div className="one-row">
                <div className="growth-t-left-header">{`Categories`}</div>
            </div>
            {renderCategory()}
            <div className="section"></div>
            <div className="one-row">
                <div className="growth-t-left-header">{`Domains`}</div>
            </div>
            {renderDomain()}
            <div className="section"></div>
            <div className="one-row">
                <div className="growth-t-left-header">{`Grades`}</div>
            </div>
            {renderGrade()}
            <div className="section"></div>
            <div className="one-row">
                <div className="growth-t-left-header">{`Schools`}</div>
            </div>
            {renderSchool()}
            <div className="section"></div>
        </div>
    );
}